import React from 'react';
import {useChart} from '../hooks';
import styled from 'styled-components';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';


const StyledChartWrapper = styled.div`
    height: 480px;
    width: 100%;
`;



const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

export default function ({data = [],
                          series = [],
                          save,
                          projectId,
                          chartId,
                          updateChart}) {
    const [ref, chart] = useChart({
        data,
        "xAxes": [{
            "type": "CategoryAxis",
            "dataFields": {
                "category": "title",
            },
            "renderer": {
                "labels": {
                  "template": {
                    "disabled": "true"
                  }
                }
            },
        }],
        "yAxes": [{
            "type": "ValueAxis",
            "min": 0,
            "max": 100,
            'tooltipText': '{title}',
            "labelsEnabled": false,
            "renderer": {
                "labels": {
                  "template": {
                    "disabled": "true"
                  }
                }
            }

        }],
        "series": [{
            "type": "LineSeries",
            "dataFields": {
              "categoryX": "country",
              "valueY": "visits"
            },
        }],
        "colors": {
          "list": [
            '#ffeb3b',
            '#ec407a',
            '#7e57c2',
            '#4caf50',
            '#ffeb3b',
            '#03a9f4',
            '#4caf50',
            '#ffeb3b'
          ]
        }
    }, am4charts.XYChart);

    const [actions, setActions] = React.useState(null);
    const [openUpdate, setOpenUpdate] = React.useState(false);
    const activCompany = series.length > 3
    const activData = data.length > 9


    React.useEffect(
        () => {
            // // console.log("!!!!!!!", chart);
            if (!chart) {
                return
            }



            const addBullet = s => {
                const bullet = s.bullets.create();
                bullet.stroke = am4core.color("#ffffff");
                bullet.strokeWidth = 3;
                bullet.opacity = 1; // initially invisible
                bullet.defaultState.properties.opacity = 1;
                // resize cursor when over
                bullet.cursorOverStyle = am4core.MouseCursorStyle.verticalResize;
                bullet.draggable = true;

                // add circle sprite to bullet
                const circle = bullet.createChild(am4core.Circle);
                circle.radius = 8;

                // while dragging
                bullet.events.on("drag", event => {
                    handleDrag(event);
                });

                bullet.events.on("dragstop", event => {
                    handleDrag(event);
                    // TODO: save dataa
                    const dataItem = event.target.dataItem;
                    dataItem.dataContext[dataItem.component.name] = dataItem.valueY;
                    // const name = dataItem.categories.categoryX;
                    // for (const item of chart.data.values) {
                    //     if (item[title] === name && item[])
                    // }
                    save({data: chart.data, series, })
                });
            };

            const addSeries = title => {
                const s = chart.series.push(new am4charts.LineSeries());
                s.dataFields.valueY = title;
                s.dataFields.categoryX = "title";
                s.name = title;
                s.strokeWidth = 3;
                addBullet(s)
            };

            series.forEach(s => addSeries(s));

            function handleDrag(event) {
                const dataItem = event.target.dataItem;
                // convert coordinate to value
                let value = chart.yAxes.values[0].yToValue(event.target.pixelY);
                // set new value
                value = value > 100 ? 100 : value;
                value = value < 0 ? 0 : value;
                dataItem.valueY = value;
                // make column hover
            }

            window.chart = chart;
            setActions({
                addRow: title => e => {
                    const obj = {title};
                    chart.series.values.forEach(item => obj[item.name] = 50)
                    chart.addData(obj)
                    save({data: chart.data, series})
                    setOpen(false)
                    setValues({
                      title: '',
                      titleCompany: ''
                    })
                },
                addSeries: title => e => {
                        // Update data
                        for (let i = 0; i < chart.data.length; i++) {
                            chart.data[i][title] = chart.series.length*10;
                        }
                        addSeries(title)
                        series.push(title);
                        chart.invalidateData();
                        save({data: chart.data, series})
                        setOpen2(false)
                        setValues({
                          title: '',
                          titleCompany: ''
                        })
                },

            })
        },
        [chart]

    );

    const [open, setOpen] = React.useState(false);
    const [open2, setOpen2] = React.useState(false);

    const classes = useStyles();

    const [values, setValues] = React.useState({
        title: '',
        titleCompany: ''
    });

    const handleChange = name => event => {
        setValues({...values, [name]: event.target.value});
    };

    // // console.log(data,'data chart')


    return (
        <>
        {actions && <div>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setOpen(true)}
            disabled={activData ? true : false}
          >
              Add Factors
          </Button>
          <Modal
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              className={classes.modal}
              open={open}
              onClose={() => setOpen(false)}
          >
              <div className={classes.paper}>
                  <h2 id="simple-modal-title">Add Factor</h2>
                  <form
                      className={classes.form}
                      noValidate autoComplete="off">
                      <TextField
                          id="title"
                          label="Name factor"
                          value={values.title}
                          onChange={handleChange('title')}/>
                  </form>
                  <br/>
                  <Button
                      variant="contained"
                      color="primary"
                      disabled={values.title.length === 0 ? true : false}
                      onClick={actions.addRow(values.title)}>
                      Ok
                  </Button>
              </div>
          </Modal>

          <Button
            variant="outlined"
            color="primary"
            onClick={() => setOpen2(true)}
            disabled={activCompany ? true : false}
          >
              Add company
          </Button>
          <Modal
              aria-labelledby="simple-modal-title2"
              aria-describedby="simple-modal-description2"
              className={classes.modal}
              open={open2}
              onClose={() => setOpen2(false)}
          >
              <div className={classes.paper}>
                  <h2 id="simple-modal-title2">Add company</h2>
                  <form
                      className={classes.form}
                      noValidate autoComplete="off">
                      <TextField
                          id="title"
                          label="Сompany Name"
                          value={values.titleCompany}
                          onChange={handleChange('titleCompany')}/>
                  </form>
                  <br/>
                  <Button
                      variant="contained"
                      color="primary"
                      disabled={values.titleCompany.length === 0 ? true : false}
                      onClick={actions.addSeries(values.titleCompany)}>
                      Ok
                  </Button>
              </div>
          </Modal>
          </div>}
          <StyledChartWrapper ref={ref}/>

          <Modal
              aria-labelledby="simple-modal-title2"
              aria-describedby="simple-modal-description2"
              className={classes.modal}
              open={openUpdate}
              onClose={() => setOpenUpdate(false)}
          >
              <div className={classes.paper}>
                  <h2 id="simple-modal-title2">Изменить </h2>

              </div>
          </Modal>



        </>
    )
}
